import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import { GetTeamClubResponse, PostTeamClubResponse, GetTeamClubByIdResponse, PutTeamClubResponse } from '../response/club';

export class ClubService {
  static getClubs(params?: QueryParams) {
    return apiClient.get<GetTeamClubResponse>(buildApiUrl('/api/v1/team/club'), params);
  }

  static postClub(data: any) {
    return apiClient.createWithFile<PostTeamClubResponse>(buildApiUrl('/api/v1/team/club'), data);
  }

  static getClubById(id: string) {
    return apiClient.get<GetTeamClubByIdResponse>(buildApiUrl('/api/v1/team/club/:id', { id }), undefined);
  }

  static putClub(id: string, data: any) {
    return apiClient.updateWithFile<PutTeamClubResponse>(buildApiUrl('/api/v1/team/club/:id', { id }), data);
  }

  static deleteClub(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/team/club/:id', { id }), undefined);
  }
}
